var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import axios from '@nextcloud/axios';
import { generateOcsUrl, generateUrl } from '@nextcloud/router';
import { showSuccess, showWarning, showError } from '@nextcloud/dialogs';
// import * as Files from '@nextcloud/files';
import { FileAction, registerFileAction } from '@nextcloud/files';
import { api } from './Common/Api';
import Vue from 'vue';
import SendFileDialog from './views/SendFileDialog.vue';
import iconBBBInline from '../img/app-dark.svg?raw';
const mimeTypes = ['application/pdf', 'application/vnd.oasis.opendocument.presentation', 'application/vnd.oasis.opendocument.text', 'application/vnd.oasis.opendocument.spreadsheet', 'application/vnd.oasis.opendocument.graphics', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/vnd.openxmlformats-officedocument.presentationml.presentation', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/msword', 'application/vnd.ms-powerpoint', 'application/vnd.ms-excel', 'image/jpeg', 'image/png', 'text/plain', 'text/rtf'];
function createDirectShare(fileId) {
  return __awaiter(this, void 0, void 0, function* () {
    var _a, _b, _c;
    const url = generateOcsUrl('apps/dav/api/v1/', undefined, {
      ocsVersion: 1,
      escape: true,
      noRewrite: true
    }) + 'direct';
    const createResponse = yield axios.post(url, {
      fileId
    });
    return (_c = (_b = (_a = createResponse.data) === null || _a === void 0 ? void 0 : _a.ocs) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.url;
  });
}
function createRoomWithFile(shareUrl, filename, roomUid) {
  return __awaiter(this, void 0, void 0, function* () {
    const joinUrl = generateUrl('/apps/bbb/b/{uid}?u={url}&filename={filename}', {
      uid: roomUid,
      url: shareUrl,
      filename
    });
    window.open(joinUrl, '_blank', 'noopener,noreferrer');
  });
}
function insertDocumentToRoom(shareUrl, filename, roomUid) {
  return api.insertDocument(roomUid, shareUrl, filename);
}
export function sendFileToBBB(fileId, filename, roomUid) {
  return __awaiter(this, void 0, void 0, function* () {
    const shareUrl = yield createDirectShare(fileId);
    const isRunning = yield api.isRunning(roomUid);
    if (isRunning) {
      try {
        const success = yield insertDocumentToRoom(shareUrl, filename, roomUid);
        if (success) {
          showSuccess(t('bbb', 'The file "{filename}" was uploaded to your room.', {
            filename
          }));
        } else {
          showWarning(t('bbb', 'The file "{filename}" could not be uploaded to your room.', {
            filename
          }));
        }
      } catch (_a) {
        showError(t('bbb', 'The file "{filename}" could not be uploaded to your room. Maybe your BigBlueButton server does not support this action.', {
          filename
        }));
      }
    } else {
      createRoomWithFile(shareUrl, filename, roomUid);
    }
  });
}
/**
 * Create a DOM component to mount the dialog Vue component
 *
 * @param fileId number
 * @param filename string
 */
export function showSendFileDialog(fileId, filename) {
  const mount = document.createElement('div');
  mount.id = 'bbb-widget-container';
  document.body.appendChild(mount);
  const vm = new Vue({
    el: '#bbb-widget-container',
    render: h => h(SendFileDialog, {
      props: {
        fileId,
        filename
      },
      on: {
        // listen to 'close' event emitted by the dialog component, to clean up
        close: () => {
          vm.$destroy();
          mount.remove();
        }
      }
    })
  });
}
/**
 * Register the file action "Send to BBB"
 */
registerFileAction(new FileAction({
  id: 'bbb-send-file',
  displayName: () => {
    return t('bbb', 'Send to BBB');
  },
  enabled: nodes => {
    // only files with the mime type allowed
    if (!Array.isArray(nodes) || nodes.length === 0) return false;
    return nodes.every(node => {
      const mime = node.mime;
      if (!mime) return false;
      // enable only for allowed mime types
      return mimeTypes.includes(mime);
    });
  },
  iconSvgInline: () => iconBBBInline,
  exec: node => __awaiter(void 0, void 0, void 0, function* () {
    showSendFileDialog(node.fileid, node.displayname);
    return null;
  }),
  order: 20
}));